export const encodeRouteSettings = ({
  adrClass: ac,
  arrivalTime: at,
  avoidFerry: af,
  avoidSelectedCountries: asc,
  axesNumber: an,
  carHeight: ch,
  co2EmissionClass: cec,
  departureTime: dt,
  emissionType: et,
  grossWeight: gw,
  numberAxes: na,
  priceType: pt,
  showInfoWindow: siw,
  tiresCount: tc,
  tolls: t,
  trafficMode: tm,
  trailerCount: trc,
  vehicleCurrentWeight: vcw,
  vehicleType: vt,
  ...otherRouteSettings
}: any) => ({
  ac,
  at,
  af,
  asc,
  an,
  ch,
  cec,
  dt,
  et,
  gw,
  na,
  pt,
  siw,
  tc,
  t,
  tm,
  trc,
  vcw,
  vt,
  ...otherRouteSettings
});

export const decodeRouteSettings = ({
  ac: adrClass,
  at: arrivalTime,
  af: avoidFerry,
  asc: avoidSelectedCountries,
  an: axesNumber,
  ch: carHeight,
  cec: co2EmissionClass,
  dt: departureTime,
  et: emissionType,
  gw: grossWeight,
  na: numberAxes,
  pt: priceType,
  siw: showInfoWindow,
  tc: tiresCount,
  t: tolls,
  tm: trafficMode,
  trc: trailerCount,
  vcw: vehicleCurrentWeight,
  vt: vehicleType,
  ...otherRouteSettings
}: any) => ({
  adrClass,
  arrivalTime,
  avoidFerry,
  avoidSelectedCountries,
  axesNumber,
  carHeight,
  co2EmissionClass,
  departureTime,
  emissionType,
  grossWeight,
  numberAxes,
  priceType,
  showInfoWindow,
  tiresCount,
  tolls,
  trafficMode,
  trailerCount,
  vehicleCurrentWeight,
  vehicleType,
  ...otherRouteSettings
});

const encodeRoutePoint = ({ coordinates: c, type: t, value: v }: any) => ({
  c,
  t,
  v
});

const decodeRoutePoint = ({ c: coordinates, t: type, v: value }: any) => ({
  coordinates,
  type,
  value
});

export const encodeRouteParams = ({
  routesSettings,
  firstPoint,
  lastPoint,
  waypoints,
  distance
}: any) => ({
  rs: encodeRouteSettings(routesSettings),
  fp: encodeRoutePoint(firstPoint),
  lp: encodeRoutePoint(lastPoint),
  wp: waypoints.map(encodeRoutePoint),
  d: distance
});

export const decodeRouteParams = ({
  rs,
  fp,
  lp,
  wp,
  d
}: any) => ({
  routesSettings: decodeRouteSettings(rs),
  firstPoint: decodeRoutePoint(fp),
  lastPoint: decodeRoutePoint(lp),
  waypoints: wp.map(decodeRoutePoint),
  distance: d
})